import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { activeNetworkSelector, userSelector } from '../../../../redux/selectors';

export const useUniversalSearch = () => {
  const [open, setOpen] = useState(false);
  const activeNetwork = useSelector(activeNetworkSelector);
  const { pathname } = useLocation();
  const user = useSelector(userSelector);

  // Check if search should be available on current page
  const isSearchAvailable =
    activeNetwork?.isManager &&
    (activeNetwork?.connect?.hasAccess || user?.email?.toLowerCase?.().endsWith('@getro.com')) &&
    pathname.startsWith(`/networks/${activeNetwork.slug}`);

  useEffect(() => {
    if (!isSearchAvailable) {
      return undefined;
    }

    const handleKeyDown = (e) => {
      // Check for Cmd+K (Mac) or Ctrl+K (Windows/Linux)
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        setOpen((prevOpen) => !prevOpen);
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isSearchAvailable]);

  return {
    open,
    setOpen,
    isSearchAvailable,
  };
};
